var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJamScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.64697C4.73478 5.64697 4.48043 5.75233 4.29289 5.93987C4.10536 6.1274 4 6.38176 4 6.64697V15.647C4 15.9122 4.10536 16.1665 4.29289 16.3541C4.48043 16.5416 4.73478 16.647 5 16.647H19C19.2652 16.647 19.5196 16.5416 19.7071 16.3541C19.8946 16.1665 20 15.9122 20 15.647V6.64697C20 6.38176 19.8946 6.1274 19.7071 5.93987C19.5196 5.75233 19.2652 5.64697 19 5.64697H5ZM5 3.64697H19C19.7956 3.64697 20.5587 3.96304 21.1213 4.52565C21.6839 5.08826 22 5.85132 22 6.64697V15.647C22 16.4426 21.6839 17.2057 21.1213 17.7683C20.5587 18.3309 19.7956 18.647 19 18.647H5C4.20435 18.647 3.44129 18.3309 2.87868 17.7683C2.31607 17.2057 2 16.4426 2 15.647V6.64697C2 5.85132 2.31607 5.08826 2.87868 4.52565C3.44129 3.96304 4.20435 3.64697 5 3.64697ZM9 19.647H15C15.2652 19.647 15.5196 19.7523 15.7071 19.9399C15.8946 20.1274 16 20.3818 16 20.647C16 20.9122 15.8946 21.1665 15.7071 21.3541C15.5196 21.5416 15.2652 21.647 15 21.647H9C8.73478 21.647 8.48043 21.5416 8.29289 21.3541C8.10536 21.1665 8 20.9122 8 20.647C8 20.3818 8.10536 20.1274 8.29289 19.9399C8.48043 19.7523 8.73478 19.647 9 19.647Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.646973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamScreen);
export default __webpack_public_path__ + "static/media/jam_screen.673f0762b37b4873e575ea98f0cbf8cc.svg";
export { ForwardRef as ReactComponent };